// @ts-nocheck
import React from 'react';

export default function AddLinkPrompt({ url, onAdd, onDismiss }: { url: string; onAdd: (url: string)=>void; onDismiss: ()=>void }) {
  if (!url) return null;
  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[80] w-[min(560px,calc(100%-24px))]">
      <div className="rounded-2xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 shadow-xl p-3 flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium truncate">Add this video?</div>
          <div className="text-xs text-gray-500 truncate">{url}</div>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={()=>onAdd(url)} className="px-3 py-1.5 text-sm rounded bg-blue-600 text-white hover:bg-blue-700">Add</button>
          <button onClick={onDismiss} className="px-3 py-1.5 text-sm rounded border border-gray-300 dark:border-gray-700">Dismiss</button>
        </div>
      </div>
    </div>
  );
}
